import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Container, Row, Col, ProgressBar } from 'react-bootstrap'; // Supondo que você use react-bootstrap

const OnboardingLayout = () => {
    const location = useLocation();
    let progress = 0;
    if (location.pathname.includes('materials')) progress = 33;
    else if (location.pathname.includes('services')) progress = 66;
    else if (location.pathname.includes('collaborators')) progress = 100;

    return (
        <Container fluid className="onboarding-container vh-100 d-flex flex-column justify-content-center align-items-center">
            <Row className="w-100 justify-content-center">
                <Col md={8} lg={6} className="text-center">
                    <h1>Configuração Inicial da Clínica</h1>
                    <ProgressBar now={progress} label={`${progress}%`} className="my-4" />
                    <main>
                        
                        <Outlet /> {/* Renderiza o componente da etapa atual */}
                        
                    </main>
                </Col>
            </Row>
        </Container>
    );
};
export default OnboardingLayout;        